import {
  Box,
  Container,
  Typography,
  Paper,
  Chip,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Schedule } from "@mui/icons-material";
import React from "react";

export const isUnderConstruction = false;

export default function ConstructionPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 2,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={8}
          sx={{
            padding: { xs: 3, md: 6 },
            textAlign: "center",
            borderRadius: 3,
            background: "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(10px)",
          }}
        >
          {/* Construction Icon */}
          <Box sx={{ mb: 3 }}>
            <img src="/img/vm-icon-512x512.png" alt="logo" width={100} />
          </Box>

          {/* Main Heading */}
          <Typography
            variant={isMobile ? "h4" : "h2"}
            component="h1"
            gutterBottom
            sx={{
              fontWeight: "bold",
              color: "#d32f2f",
              mb: 2,
            }}
          >
            Веб-страницата е недостапна
          </Typography>

          {/* Subtitle */}
          <Typography
            variant={isMobile ? "h6" : "h5"}
            color="text.secondary"
            sx={{ mb: 4, fontWeight: 300 }}
          >
            Веб-страницата моментално не работи
          </Typography>

          {/* Status Chip */}
          <Chip
            icon={<Schedule />}
            label="Страницата е недостапна"
            color="error"
            variant="outlined"
            sx={{ mb: 4, fontSize: "1rem", py: 2 }}
          />

          {/* Expected Launch */}
          <Typography variant="h6" sx={{ mb: 3, color: "#555" }}>
            Ќе биде достапна наскоро
          </Typography>

          {/* Contact Information */}

          {/* Footer Message */}
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 4, fontStyle: "italic" }}
          >
            Ви благодариме за стрпението
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}

export const withConstruction = (element) => {
  if (isUnderConstruction) {
    return <ConstructionPage />;
  }
  return element;
};
